var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 3.99984H7.33398V2.6665H6.00065V3.99984ZM8.66732 3.99984V2.6665H10.0007V3.99984H8.66732ZM6.00065 9.33317V7.99984H7.33398V9.33317H6.00065ZM11.334 6.6665V5.33317H12.6673V6.6665H11.334ZM11.334 9.33317V7.99984H12.6673V9.33317H11.334ZM8.66732 9.33317V7.99984H10.0007V9.33317H8.66732ZM11.334 3.99984V2.6665H12.6673V3.99984H11.334ZM7.33398 5.33317V3.99984H8.66732V5.33317H7.33398ZM3.33398 13.3332V2.6665H4.66732V3.99984H6.00065V5.33317H4.66732V6.6665H6.00065V7.99984H4.66732V13.3332H3.33398ZM10.0007 7.99984V6.6665H11.334V7.99984H10.0007ZM7.33398 7.99984V6.6665H8.66732V7.99984H7.33398ZM6.00065 6.6665V5.33317H7.33398V6.6665H6.00065ZM8.66732 6.6665V5.33317H10.0007V6.6665H8.66732ZM10.0007 5.33317V3.99984H11.334V5.33317H10.0007Z",
    fill: "#5F6368",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.826d6d645c093091e3259f03cf63b0fe.svg";
export { ForwardRef as ReactComponent };